
<modal
  size="full"
  :title="isCertUpload ? 'Upload Certs' : 'Upload Collection'"
  :open="open"
  @close="closeModal"
>
  <p class="description">
    <span>In order to get {{ isCertUpload ? 'your PSA, BGS, SGC or CGC cards uploaded' : 'your collection uploaded' }} accurately we need you to format your spreadsheet.</span>
    <a :href="sampleUploadUrl" target="_blank">
      Look at a sample spreadsheet here for an example.
    </a>
    <span>It's important that you name the column headers properly but the order of columns doesn't matter.</span>
    <span>We currently only support .csv file format and you can only upload {{ maxCards }} cards at a time.</span>
  </p>

  <div v-if="output.text" class="output">
    <p>{{ output.text }}</p>
    <p v-if="output.progress">
      Finished uploading {{ output.progress }} of {{ output.cards.length }} cards
    </p>

    <btn
      v-if="isReady"
      :loading="saving"
      @click="submit"
    >
      Upload
    </btn>
  </div>

  <div v-show="!loading && !isReady" class="file-upload">
    <input
      ref="input"
      type="file"
      accept=".csv"
      @change="handleUpload"
    />

    <div class="placeholder">
      <icon class="icon" name="file_upload" />
      <div>{{ isCertUpload ? 'Upload your Graded Certs' : 'Upload your CSV' }}</div>
    </div>
  </div>

  <div v-if="loading" class="loading">
    <spinner />
  </div>
</modal>
